app-overlay {
	&:not([active]) {
		opacity: 0;
	}

	&[active] {
		position: fixed;
		inset: 0;
		z-index: $zindex-modal-backdrop;
		backdrop-filter: contrast(55%) brightness(35%) blur(4px);
		opacity: 1;
		transition: opacity 0.175s ease-in;

		@supports (-webkit-backdrop-filter: blur(4px)) {
			backdrop-filter: none;
			-webkit-backdrop-filter: none;
			background: rgba(0, 0, 0, 0.7); /* Safari fallback */
		}

		&[under-next-sibling] + * {
			z-index: $zindex-modal;
		}
	}
}
